// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__13U5v","containerItemsCenter":"Skeleton_containerItemsCenter__2Ucat"};